import React from 'react'
import FAQComponent from './faq/FAQComponent'

const Faq = () => {
    return (
        <FAQComponent />
    )
}

export default Faq